export const HeaderData = [
    {
    title: "Home",
    path: "/Home",
  },
  {
    title: "About Us",
    path: "/Home/About_Us",
    heading: "Get Everything About Us",
  },
  {
    title: "Our Service",
    path: "#",
    subNav: [
      {
        subTitle: "Our Services",
        heading: " Pick a Service to Get Started ",
        path: "/Home/Our_Services",
      },
      {
        subTitle: "Service Details",
        heading: "Anti Lock Brake Servicing",
        path: "/Home/Our_Services/Service_Details",
      },
    ],
  },
  {
    title: "Other Pages",
    path: "#",
    subNav: [
        {
        subTitle: "Company History",
        heading: "When and How We start This Company",
        path: "/Home/Company_History",
      },
      {
        subTitle: "Our Team",
        heading: "Meet Our Awesome Team",
        path: "/Home/Our_Team",
      },
      {
        subTitle: "Team Details",
        heading: "About Williams ( Team Single )",
        path: "/Home/Our_Team/Team_Details",
      },

      {
        subTitle: "Testimonial",
        heading: "What They Say About Us",
        path: "/Home/Testimonial",
      },
      {
        subTitle: "Gallery",
        heading: "Let’s See Our Recent Works",
        path: "/Home/Gallery",
      },
      {
        subTitle: "Gallery Details",
        heading: "Car Belt Replacement",
        path: "/Home/Gallery/Gallery_Details",
      },
      {
        subTitle: "FAQ",
        heading: "Usually Asked Question From Client",
        path: "/Home/FAQ",
      },
      {
        subTitle: "Pricing Table",
        heading: "Awesome Pricing Plane",
        path: "/Home/Pricing_Table",
      },
      {
        subTitle: "Comming Soon",
        heading: "Comming Soon",
        path: "/Home/Comming_Soon",
      },
      {
        subTitle: "404",
        heading: "404 Error",
        path: "/Home/Error404",
      },
    ],
  },
  {
    title: "Blogs",
    path: "#",
    subNav: [
      {
        subTitle: "Blogs",
        heading: "Read our News and Blogs",
        path: "/Home/Blogs",
      },
      {
        subTitle: "Blog Lists",
        heading: "Read our News and Blogs",
        path: "/Home/Blog_Lists",
      },
      {
        subTitle: "Blog Details",
        heading: "Why Does My Car Heater Blow Cold Air?",
        path: "/Home/Blogs/Blog_Details",
      },
    ],
  },
   {
    title: "Contact Us",
    path: "/Home/Contact_Us",
    heading: "Let’s Get in Touch",
  },
  {
    title: "Make An Appointment",
    heading: "Book an Appointment",
    path: "/Home/Make_An_Appointment",
  },
]